/* eslint-disable import/prefer-default-export */

export const splitFileRequestsAndFiles = (fileRequests, uploadedFiles) => {
  const unfulfilledFileRequests = fileRequests?.filter(req => !req.fileUploadId) ?? [];
  const fulfilledFileRequests =
    fileRequests
      ?.filter(req => req.fileUploadId)
      .map(req => ({
        ...req,
        uploadedFile: uploadedFiles?.find(file => String(file.id) === String(req.fileUploadId))
      })) ?? [];
  const additionalFiles =
    uploadedFiles?.filter(
      file => !fileRequests?.some(req => String(req.fileUploadId) === String(file.id))
    ) ?? [];

  return { unfulfilledFileRequests, fulfilledFileRequests, additionalFiles };
};
